import { Link } from "react-router-dom";
import clsx from "clsx";
import { checkIsNewProduct, stripHTML } from "@/utils/utils";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
import { PLACEHOLDER_IMAGE } from "@/constants/common";
import ProductPrice from "@/components/features/products/ProductPrice";
import type { Product } from "@/types/products";

interface ProductCardProps {
  product: Product;
}

const ProductCard = ({ product }: ProductCardProps) => {
  const isTouchDevice = useIsTouchDevice();

  const {
    id,
    name,
    slug,
    short_description,
    on_sale,
    prices: { price, regular_price, price_range },
    images,
    is_purchasable,
    is_in_stock,
    categories,
  } = product;

  const productImg = images[0]?.src ?? PLACEHOLDER_IMAGE;
  const hoverImg = images[1]?.src;
  const isPurchasable = is_in_stock && is_purchasable;
  const isNewProduct = checkIsNewProduct(categories);

  return (
    <div key={id} className={clsx("relative flex flex-col gap-1", !isPurchasable && "opacity-50")}>
      {isNewProduct && (
        <span className="absolute right-2 top-2 z-20 rounded bg-accent px-2 py-1 text-xs text-white opacity-80">
          新品
        </span>
      )}
      {!isPurchasable && (
        <span className="absolute right-2 top-2 z-20 rounded bg-black px-2 py-1 text-xs text-white opacity-50">
          售完
        </span>
      )}
      {/* Product Image */}
      <Link to={`/product/${slug}`} className="brand-product-placeholder group relative block">
        <img
          src={productImg}
          alt={name}
          className={clsx("absolute inset-0 z-10 h-full w-full object-cover", {
            "group-hover:z-0": !isTouchDevice,
          })}
        />
        <img
          src={hoverImg || PLACEHOLDER_IMAGE}
          alt={name}
          loading="lazy"
          className={clsx("absolute inset-0 z-0 h-full w-full object-cover", {
            "group-hover:z-10": !isTouchDevice,
          })}
        />
      </Link>

      {/* Product Name */}
      <Link className="block" to={`/product/${slug}`}>
        <h2 className="brand-text-md line-clamp-2 font-bold text-black hover:underline hover:underline-offset-4">
          {name}
        </h2>
      </Link>

      {/* Product Description */}
      {short_description && (
        <p className="brand-text-sm truncate text-neutral">{stripHTML(short_description)}</p>
      )}

      {/* Price ：如果有價格範圍則顯示範圍，否則顯示單一價格 */}
      <ProductPrice
        price={price}
        regular_price={regular_price}
        on_sale={on_sale}
        price_range={price_range}
      />
    </div>
  );
};

export default ProductCard;
